function InitialPrompt({ twoFilter }) {
  return (
    <div className="text-center align-items-center mt-4">
      <img
        src="./choosefirst.png"
        alt="choose first"
        style={{ height: "200px", width: "200px" }}
      />
      {twoFilter ? (
        <h4 className="mt-4 fw-semibold text-muted text-center">
          👋 To get started, please select a{" "}
          <span className="text-success">date range</span> and{" "}
          <span className="text-success">store</span> above.
        </h4>
      ) : (
        <h4 className="mt-4 fw-semibold text-muted text-center">
          👋 To get started, please select a{" "}
          <span className="text-success">store</span>,{" "}
          <span className="text-success">month</span> and{" "}
          <span className="text-success">year</span> above.
        </h4>
      )}
    </div>
  );
}

export default InitialPrompt;
